import {useCallback, useRef, useState} from 'react';
import {IconButton, makeStyles, Menu, MenuItem, Tooltip} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {
  exportExperiencesAsZip,
  exportXLSX,
  getShareLink,
  getUrlEncodeConvert,
  updateSettings
} from '../../../store/actions/creator/analysis';
import CustomizedSnackbars from '../../pages/creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import {updateUserMetricsValue} from '../../../store/actions/auth/auth';
import {useStylesTooltip} from '../../../config/theme';
import PreviewPDFModal from '../modals/previewPDFModal';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {useLocation} from 'react-router-dom';
import axios from 'axios'
import Config from "../../../config/config";
import apiConfigs from "../../../config/config";
import {useFeature} from 'flagged';
import lockIcon from '@material-ui/icons/Lock';
import Icon from '@material-ui/core/Icon';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import {Mixpanel} from "../../../helper/mixpanel";

const useStyles = makeStyles(() => ({
  iconBtn: {
    width: 40,
    borderRadius: 10,
    background: 'transparent',
    '&:hover': {
      background: '#017AEF14'
    }
  },
  menuItem: {
    padding: 0,
    '& .MuiPaper-root': {
      textDecoration: 'none'
    }
  },
  btn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 20,
    marginLeft: 20,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0'
  },
}));

interface IProps {
  clipped?: any,
  useNewStyle?: boolean,
  fontColor?: string
}

function XLSXDownloadBtn(props: IProps) {

  const classes = useStyles();
  const { clipped, useNewStyle, fontColor } = props;
  const tooltipClasses = useStylesTooltip();
  const downloadRef = useRef(null);
  const dispatch = useDispatch();
  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const { currentSession, settings, cliped } = useSelector((state: any) => state.analysis);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const participants = useSelector((state: any) => state.experience.participants);
  const {compareData, sortKey, sortType, sortImmersion } = useSelector((state: any) => state.compare);
  const { videoBase64Img, clip } = settings;
  const { session_status, braintrust_id, session_type } = currentSession;
  const [openRightMenu, setOpenRightMenu] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [message, setMessage] = useState('');
  const [isOpenMessage, setIsOpenMessage] = useState(false);
  const [messageType, setMessageType] = useState("success");
  const [modal, setModal] = useState(false);
  const location = useLocation<any>();
  const isAnalyze = location.pathname.includes('/experience-manager/analyze') && !clip
  const isOverview = location.pathname.includes('/experience-manager/overview')
  const isCompare = location.pathname.includes('/experience-manager/compare')
  const [isLoadingPPT, setIsLoadingPPT] = useState(false);
  const isAgendaAvailable = session_type !== 'ASYNC';

  const hasFeatureExportData = useFeature('feature_export_data');
  const hasFeatureExportPpt = useFeature('feature_export_ppt');
  const hasFeatureExportPdf = useFeature('feature_export_pdf');

  const downloadXLSXData = (export_url: string) => {
    const a = document.createElement('a');
    a.href = export_url;
    a.download = 'download.xlsx';
    a.click();
    setIsDownloading(false);
  };

  const exportData = useCallback(() => {
    Mixpanel.identify(loginUserData.user_id);
    Mixpanel.track('download_xlsx', {
      'Experience Type': `${currentSession.session_type}`,
      'Experience Owner': `${currentSession.user.first_name} ${currentSession.user.last_name}`
    });
    Mixpanel.people.set({
      $email: loginUserData.username,
      $first_name: loginUserData.first_name,
      $last_name: loginUserData.last_name,
      $team: loginUserData.department_name,
      $type: loginUserData.role_alias
    });

    setOpenRightMenu(false);
    setIsDownloading(true);
    if (currentSessionCode) {
      if (clipped) { // Second by second tab for loaded clip
        const request = {
          clips: [
            { session_code: clipped.session_code, clip_ids: [clipped.clip_id] }
          ]
        };

        dispatch(exportExperiencesAsZip(loginUserData.customer_id, request, (res: any) => {
          if (res) {
            downloadXLSXData(res);
          } else {
            showErrorMsg();
          }
        }))
      } else {
        const req = {
          tenant_id: loginUserData.customer_id,
          session_code: currentSessionCode
        };
        dispatch(exportXLSX(req, (url: any) => {
          if (url) {
            if (session_status === 'COMPLETED' && !braintrust_id) {
              dispatch(updateUserMetricsValue(apolloClient.client, {
                user_id: loginUserData.user_id,
                metrics_type: "EXPERIENCESEXPORT"
              }))
            }
            downloadXLSXData(url);
          } else {
            showErrorMsg();
          }
        }));
      }
    }
  }, [clipped, currentSessionCode, currentSession, session_status, loginUserData]);

  const showErrorMsg = () => {
    setIsDownloading(false);
    setMessageType("error");
    setIsOpenMessage(true);
    setMessage('Cannot download XLSX file on this experience!');
  };

  const sleep = (milliseconds: number) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  };

  const exportPDF = async () => {
    Mixpanel.identify(loginUserData.user_id);
    Mixpanel.track('download_pdf', {
      'Experience Type': `${currentSession.session_type}`,
      'Experience Owner': `${currentSession.user.first_name} ${currentSession.user.last_name}`
    });
    Mixpanel.people.set({
      $email: loginUserData.username,
      $first_name: loginUserData.first_name,
      $last_name: loginUserData.last_name,
      $team: loginUserData.department_name,
      $type: loginUserData.role_alias
    });

    setOpenRightMenu(false);
    dispatch(updateSettings('pdfLoading', true));

    if (!videoBase64Img) {
      await dispatch(getUrlEncodeConvert(apolloClient.client, { url: [participants?.session?.large_thumbnail] }, (res: any) => {
        dispatch(updateSettings('videoBase64Img', 'data:image/jpeg;base64,' + res[0]))
      }))
    }

    if (!braintrust_id) {
      dispatch(updateUserMetricsValue(apolloClient.client, {
        user_id: loginUserData.user_id,
        metrics_type: "EXPERIENCESEXPORT"
      }))
    }

    await sleep(1800);
    isAnalyze && generatePDFAnalyze();
    isOverview && generatePDFOverview();
    // isCompare && generatePDFCompare();
  };

  const handleMenuRightOpen = () => {
    setOpenRightMenu(true);
  };

  const handleMenuRightClose = () => {
    setOpenRightMenu(false);
  };

  const onClose = () => {
    setMessage('');
    setIsOpenMessage(false);
  }

  const generatePDFOverview = async () => {

    const inputKeyPerformance: any = document.getElementById('OverviewKeyPerformance');
    const canvasKeyPerformance = await html2canvas(inputKeyPerformance)
    const imgDataKeyPerformance = canvasKeyPerformance.toDataURL('image/png', 1.0);

    const inputAgenda: any = document.getElementById(isAgendaAvailable ? 'OverviewAgenda' : 'OverviewKeyPerformance');
    const canvasAgenda = await html2canvas(inputAgenda);
    const imgDataAgenda = canvasAgenda.toDataURL('image/png', 1.0);

    const inputLights: any = document.getElementById('OverviewLights');
    const canvasLights = await html2canvas(inputLights);
    const imgDataLights = canvasLights.toDataURL('image/png', 1.0);

    const inputKeyAudience: any = document.getElementById('OverviewAudience');
    const canvasAudience = await html2canvas(inputKeyAudience);
    const imgDataAudience = canvasAudience.toDataURL('image/png', 1.0);

    const pdf = new jsPDF("p", "mm", "a4");

    const imgProps1 = pdf.getImageProperties(imgDataKeyPerformance);
    const imgProps2 = pdf.getImageProperties(imgDataAgenda);
    const imgProps3 = pdf.getImageProperties(imgDataLights);
    const imgProps4 = pdf.getImageProperties(imgDataAudience);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    // const pdfWidth = 210;
    const pdfHeight1 = (imgProps1.height * pdfWidth) / imgProps1.width;
    const pdfHeight2 = (imgProps2.height * pdfWidth) / imgProps2.width;
    const pdfHeight3 = (imgProps3.height * pdfWidth) / imgProps3.width;
    const pdfHeight4 = (imgProps4.height * pdfWidth) / imgProps4.width;

    pdf.addImage(imgDataKeyPerformance, 'PNG', 0, 0, pdfWidth, pdfHeight1);
    pdf.addPage();

    if (isAgendaAvailable) {
      pdf.addImage(imgDataAgenda, 'PNG', 0, 0, pdfWidth, pdfHeight2);
      pdf.addPage();
    }

    pdf.addImage(imgDataLights, 'PNG', 0, 0, pdfWidth, pdfHeight3);
    pdf.addPage();
    pdf.addImage(imgDataAudience, 'PNG', 0, 0, pdfWidth, pdfHeight4);

    pdf.save("overview.pdf");
    dispatch(updateSettings('pdfLoading', false))
  }

  const generatePDFAnalyze = async () => {
    const input: any = document.getElementById('analyze');
    const canvas = await html2canvas(input)
    const imgData = canvas.toDataURL('image/png', 1.0);

    const input1: any = document.getElementById('topbar');
    const canvas1 = await html2canvas(input1)
    const headerData = canvas1.toDataURL('image/png', 1.0);

    const pdf = new jsPDF();

    const imgProps = pdf.getImageProperties(imgData);
    const headerProps = pdf.getImageProperties(headerData);

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    const headerHeight = (headerProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(headerData, 'PNG', 0, 0, pdfWidth, headerHeight);

    pdf.addImage(imgData, 'PNG', 0, headerHeight + 1, pdfWidth, pdfHeight);
    if (pdfHeight > 298) {
      pdf.addPage()
      pdf.addImage(imgData, 'PNG', 0, -298 + headerHeight + 1, pdfWidth, pdfHeight);
    }
    if (pdfHeight > 596) {
      pdf.addPage()
      pdf.addImage(imgData, 'PNG', 0, -596 + headerHeight + 1, pdfWidth, pdfHeight);
    }

    pdf.save("analyze.pdf");
    dispatch(updateSettings('pdfLoading', false))
  }

  if (session_status !== 'COMPLETED') {
    return <></>
  }

  const downloadPPT = async () => {
    Mixpanel.identify(loginUserData.user_id);
    Mixpanel.track('download_ppt', {
      'Experience Type': `${currentSession.session_type}`,
      'Experience Owner': `${currentSession.user.first_name} ${currentSession.user.last_name}`
    });
    Mixpanel.people.set({
      $email: loginUserData.username,
      $first_name: loginUserData.first_name,
      $last_name: loginUserData.last_name,
      $team: loginUserData.department_name,
      $type: loginUserData.role_alias
    });

    setIsLoadingPPT(true)

    const ids = compareData[compareData.length-1]?.compareList.map((x: any) => {
      if (x.clip_id) {
        return {
          clip_id: x.clip_id.replace('clip-', ''),
          session_code: x.session_code,
          from_clip: x.start + '',
          to_clip: x.end + '',
          clip_image:`${apiConfigs.S3_IMG_URL}/large-${typeof x.immersion === 'number' ? (x.immersion % 70 + 1) : 64}.svg`,
          clip_title: x.name
        }
      } else {
        return {
          session_code: x.session_code
        }
      }
    }).filter((x: any) => x.session_code !== 'industry_norm');

    const variables = isCompare ? {
      session_code: ids.find((x: any) => x.session_code === currentSessionCode),
      compare_session_codes: ids.filter((x: any) => cliped ? (x?.clip_id !== cliped?.clip_id) : (x?.clip_id !== cliped?.clip_id || x.session_code !== currentSessionCode)),
      immersion_sort: sortImmersion,
      sort_key: sortKey,
      sort_type: sortType,
      tab: "comparison"
    }: {
      session_code: cliped ? {
        clip_id: cliped.clip_id,
        session_code: currentSessionCode,
        from_clip: cliped.start_clip + '',
        to_clip: cliped.end_clip + '',
      } : {session_code: currentSessionCode},
      compare_session_codes: [],
      immersion_sort: true,
      sort_key: "",
      sort_type: "",
      tab: "report_card"
    }
    
    const request = cliped ? { 
      session_code: currentSessionCode,
      clip_data: {
        clip_id: cliped.clip_id,
        session_code: currentSessionCode,
        from_clip: cliped.start_clip + '',
        to_clip: cliped.end_clip + '',
      }
    } : {session_code: currentSessionCode,}

    dispatch(getShareLink(apolloClient.client, request, async (res: any) => {
      const shareResponse = res?.share?.data?.uuid
      if (shareResponse) {
        await axios.post(Config.DOCUMENT_API_URL,
          {
            query: `query generateExperiencePpt($session_code: JSON!, $compare_session_codes: [JSON!], $sort_key: String, $sort_type: String, $tab: String, $immersion_sort: Boolean! ) {
                      generateExperiencePpt(session_code: $session_code, compare_session_codes: $compare_session_codes, sort_key: $sort_key, sort_type: $sort_type, tab: $tab, immersion_sort: $immersion_sort) {
                        status message
                      }
                  }`,
            variables
          },
          {
            headers: {
              accesstoken: localStorage.getItem("auth_token") ? localStorage.getItem("auth_token") : "",
              schemaname: loginUserData && loginUserData.customer_name ? loginUserData.customer_name : "",
              idToken: localStorage.getItem("idToken") ? localStorage.getItem("idToken") : ""
            }
          }).then(async (result: any) => {
            setIsLoadingPPT(false)
            handleMenuRightClose()
            const resultStatus = result?.data?.data?.generateExperiencePpt?.status
            if (resultStatus === 'true') {
              setMessageType('success')
              setMessage('PPT generation is processing. You will receive an email when it is done.')
              setIsOpenMessage(true)
            } else {
              setMessageType('error')
              setMessage("PPT generation failed.  Please contact support.")
              setIsOpenMessage(true)
            }
          }).catch(() => {
            setIsLoadingPPT(false)
            setMessageType('error')
            setMessage("PPT generation failed.  Please contact support.")
            setIsOpenMessage(true)
            handleMenuRightClose()
          });

        if (!braintrust_id) {
          dispatch(updateUserMetricsValue(apolloClient.client, {
            user_id: loginUserData.user_id,
            metrics_type: "EXPERIENCESEXPORT"
          }))
        }

      } else {
        setMessageType('error')
        setMessage('Can not share the UUID for this session.')
        setIsOpenMessage(true)
        setIsLoadingPPT(false)
        handleMenuRightClose()
      }
    }))
  }

  return (
    <>
      <Tooltip classes={tooltipClasses} title="Export Data" placement="bottom" arrow>

        {!useNewStyle ? (

        <IconButton
          className={classes.iconBtn}
          size='small'
          style={{ marginRight: 20 }}
          ref={downloadRef}
          onClick={handleMenuRightOpen}
        >
          <img src={'/assets/icons/download_icon.svg'} alt='img' />
        </IconButton>
        ) : (
          <IconButton aria-label="settings"
            ref={downloadRef}
            onClick={handleMenuRightOpen}
          >
            <CloudDownloadIcon style={{color: fontColor}} />
          </IconButton>
        )}
      </Tooltip>

      <Menu
        anchorEl={downloadRef.current}
        elevation={1}
        onClose={handleMenuRightClose}
        open={openRightMenu || isDownloading}
        PaperProps={{
          style: { width: 'auto', marginTop: 50, borderRadius: 12 }
        }}
      >
        <MenuItem
          className={classes.menuItem}
          onClick={() => handleMenuRightClose}
        >


          {hasFeatureExportData ?
            <div id='download_xlsx' className={classes.btn} onClick={exportData}>
              {isDownloading && <CircularProgress color="inherit" size={15} />}
              Download XLSX
            </div>
            :
            <div id='download_xlsx' className={classes.btn} >
              <Icon component={lockIcon} color="primary" />
              Download XLSX
            </div>
          }


        </MenuItem>
        {!isCompare && !isOverview && !clip && <MenuItem
          className={classes.menuItem}
          onClick={() => handleMenuRightClose}
        >
          {hasFeatureExportPdf ?
            <div id='download_pdf' className={classes.btn} onClick={exportPDF}>
              Download PDF
              {isAnalyze && ' Second-by-Second'}
              {isOverview && ' Report Card'}
            </div>
            :
            <div id='download_pdf' className={classes.btn} >
              <Icon component={lockIcon} color="primary" />
              Download PDF
              {isAnalyze && ' Second-by-Second'}
              {isOverview && ' Report Card'}
            </div>
          }
        </MenuItem>}
        <MenuItem
          className={classes.menuItem}
          onClick={() => handleMenuRightClose}
        >
          {hasFeatureExportPpt ?
            <div id='download_ppt' className={classes.btn} onClick={downloadPPT}>
              {isLoadingPPT && <CircularProgress color="inherit" size={15} />}
              Download PPT
            </div>
            :
            <div id='download_ppt' className={classes.btn}>
              <Icon component={lockIcon} color="primary" />
              Download PPT
            </div>
          }
        </MenuItem>
      </Menu>

      <CustomizedSnackbars
        type={messageType}
        message={message}
        open={isOpenMessage}
        onClose={onClose}
      />

      <PreviewPDFModal
        open={modal}
        onClose={() => setModal(false)}
      />
    </>
  )
}

export default XLSXDownloadBtn;